import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import TextInput from '../../../TextInput';
import AsyncPaginatedSelect from '../../../common/AsyncPaginatedSelect';

import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../../../constants/formFields';

import {
  getFieldProps,
  FIELD_FILLING_TYPES,
} from '../../../../utils/fields/getFieldProps';

import styles from './index.styl';

const {
  MEMBER_ID,
  GROUP_NUMBER,
  HEALTH_PLAN,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

const MainInsuranceFormSection = ({
  formState,
  handleFormChange,
  handleHealthPlanChange,
  entities,
  handleInputChange,
  handleMenuScrollToBottom,
  isLoading,
  isPlanNotListedSelected,
}) => {
  const { formatMessage } = useIntl();

  const placeholderHealthPlan = formatMessage({
    id: 'profile.section.insurance.healthPlan',
  });

  const makeField = getFieldProps(formatMessage, handleFormChange);

  return (
    <section className={styles.section}>
      <div className={styles.healthPlanSelect}>
        <AsyncPaginatedSelect
          handleInputChange={handleInputChange}
          isLoading={isLoading}
          label={placeholderHealthPlan}
          onChange={handleHealthPlanChange}
          onMenuScrollToBottom={handleMenuScrollToBottom}
          options={entities}
          placeholder={placeholderHealthPlan}
          value={formState[HEALTH_PLAN]}
        />
      </div>
      <TextInput
        {...makeField(MEMBER_ID)}
        disabled={isPlanNotListedSelected}
        withTrimMode
        required={false}
        value={formState[MEMBER_ID]}
      />
      <TextInput
        {...makeField(GROUP_NUMBER, FIELD_FILLING_TYPES.OPTIONAL)}
        disabled={isPlanNotListedSelected}
        value={formState[GROUP_NUMBER]}
      />
    </section>
  );
};

MainInsuranceFormSection.propTypes = {
  formState: PropTypes.object.isRequired,
  isPlanNotListedSelected: PropTypes.bool,
  handleFormChange: PropTypes.func.isRequired,
  handleHealthPlanChange: PropTypes.func.isRequired,
  entities: PropTypes.array.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleMenuScrollToBottom: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default MainInsuranceFormSection;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/MainInsuranceFormSection/index.jsx